export default __webpack_public_path__ + "static/media/Project01.39e2f16e.jpg";